import { __awaiter } from "tslib";
import Vue from 'vue';
import ipsListItem from './components/ipsListItem/index.vue';
import { ApiKeysAsideModes } from '@/components/pages/apiKeysPage/interfaces';
import { copyToClipboard } from '@/utils/other';
import { mapGetters } from 'vuex';
import { StepByStepGlossary } from '@/constants/services';
import { YubikeyAuthMixin } from '@/mixins/YubikeyAuthMixin';
const setData = (vm, item) => {
    const fields = vm.form.fields;
    fields.name.value = item.name;
    fields.permissions.spot.value = item.permissions.spot;
    fields.permissions.futures.value = item.permissions.futures;
    fields.ip_filter.value = item.ip_filter;
    fields.ips.value = item.ips;
};
export default Vue.extend({
    name: 'apiKeysKeyBuildShell',
    mixins: [YubikeyAuthMixin],
    props: {
        item: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            preSubmit: false,
            requestSended: false,
            haveNewAddresses: false,
            editingKeyName: true,
            form: {
                valid: false,
                fields: {
                    name: {
                        value: '',
                        rules: [
                            (v) => v.length > 0 || this.$t('apiKeysPage.errors.required')
                        ]
                    },
                    permissions: {
                        spot: {
                            value: false
                        },
                        futures: {
                            value: false
                        }
                    },
                    ip_filter: {
                        value: false
                    },
                    ips: {
                        value: []
                    },
                    password: {
                        valid: false,
                        type: 'password',
                        value: '',
                        rules: [
                            (v) => Boolean(v) || this.$t('apiKeysPage.errors.required')
                        ]
                    }
                }
            }
        };
    },
    watch: {
        'form.fields.ips.value': {
            handler(v) {
                const vm = this;
                vm.haveNewAddresses = v.filter((item) => item.isNew).length > 0;
            },
            deep: true
        },
        item() {
            const vm = this;
            if (Object.keys(vm.item).length) {
                setData(vm, vm.item);
            }
        }
    },
    methods: {
        changeKeyNameEditHandler() {
            if (this.form.fields.name.value)
                this.editingKeyName = false;
        },
        changePasswordInputType(item) {
            const vm = this;
            vm.form.fields[item].type = vm.form.fields[item].type === 'password' ? 'text' : 'password';
        },
        handleAddIP() {
            const vm = this;
            vm.form.fields.ips.value.splice(0, 0, {
                isNew: true,
                ip: '',
                name: '',
                copied: false,
                isEditing: true
            });
        },
        handleSaveIP(item, newData) {
            delete item.isNew;
            item.name = newData.name;
            item.ip = newData.ip;
            item.isEditing = false;
        },
        handleCancelIP(index) {
            const vm = this;
            if (vm.form.fields.ips.value[index].name.length > 0) {
                vm.form.fields.ips.value[index].isEditing = false;
            }
            else {
                vm.form.fields.ips.value.splice(index, 1);
            }
        },
        handleClickCopy(index) {
            const vm = this;
            vm.form.fields.ips.value.forEach((item, itemIndex) => {
                if (itemIndex !== index) {
                    item.copied = false;
                }
                else {
                    copyToClipboard(item.ip).then(() => {
                        item.copied = true;
                    });
                }
            });
        },
        saveItem() {
            return __awaiter(this, void 0, void 0, function* () {
                const vm = this;
                vm.requestSended = true;
                const fields = vm.form.fields;
                const isCreateMode = this.mode === ApiKeysAsideModes.create;
                const confirmSessionId = isCreateMode ? StepByStepGlossary.createApiKey : StepByStepGlossary.updateApiKey;
                const confirmationType = vm.getUserData.confirmation;
                if (confirmationType === 'yubikey') {
                    const yubikeySaveItem = () => {
                        this.YubikeyAuth(confirmSessionId, confirmSessionId, (authResponse, sessionId) => __awaiter(this, void 0, void 0, function* () {
                            var _a;
                            if (!authResponse.success) {
                                vm.$store.commit('popupModule/setClosed');
                                vm.$store.dispatch('alertsBus/openAlert', {
                                    title: vm.$t('apiKeysPage.alerts.titles.error'),
                                    type: 'error',
                                    autoDelete: true,
                                    content: (_a = authResponse.errors.join('\n')) !== null && _a !== void 0 ? _a : vm.$t('apiKeysPage.alerts.content.failedExecuteOperation')
                                });
                                return;
                            }
                            this.$emit('onSaveItem', {
                                session_id: sessionId,
                                name: fields.name.value,
                                id: this.mode === ApiKeysAsideModes.create ? -1 : this.item.id,
                                permissions: {
                                    spot: fields.permissions.spot.value,
                                    futures: fields.permissions.futures.value
                                },
                                ip_filter: fields.ip_filter.value,
                                ips: fields.ips.value.filter((item) => item.name.length > 0)
                            });
                        }), null, yubikeySaveItem);
                    };
                    yubikeySaveItem();
                    return;
                }
                const response = yield vm.services.mainService.confirmSession({ sessionId: confirmSessionId });
                if (!response.success) {
                    vm.$store.commit('popupModule/setClosed');
                    vm.$store.dispatch('alertsBus/openAlert', {
                        title: 'Ошибка',
                        type: 'error',
                        autoDelete: true,
                        content: vm.$t('apiKeysPage.alerts.content.failedExecuteOperation')
                    });
                    return;
                }
                const sessionId = response.data.session_id;
                const confirmations = response.data.confirmations;
                const smsVerify = vm.getUserData.confirmation === 'sms';
                vm.$store.dispatch('popupModule/openPopup', {
                    type: 'action',
                    letDefaultClose: true,
                    title: isCreateMode ? vm.$t('apiKeysPage.popups.titles.keyCreating', { name: fields.name.value }) : vm.$t('apiKeysPage.popups.titles.keyEditing', { name: fields.name.value }),
                    content: smsVerify ? vm.$t('apiKeysPage.popups.content.confirmViaSMS') : vm.$t('apiKeysPage.popups.content.confirmViaGA'),
                    slot: {
                        name: smsVerify ? 'commonConfirmSMSPopupChunk' : 'commonConfirmGAPopupChunk',
                        data: {
                            isLoading: false,
                            codes: confirmations,
                            sessionId,
                            responseErrors: []
                        },
                        on: {
                            onSubmit(payload) {
                                return __awaiter(this, void 0, void 0, function* () {
                                    vm.$store.commit('popupModule/setSlotData', { isLoading: true });
                                    const validateSessionResponse = yield vm.services.mainService.validateSession({ payload: { [confirmationType]: payload[`code_${confirmationType}`] }, sessionId });
                                    if (!validateSessionResponse.success) {
                                        vm.$store.commit('popupModule/setSlotData', { responseErrors: validateSessionResponse.data.errors, isLoading: false });
                                        return;
                                    }
                                    vm.$emit('onSaveItem', {
                                        session_id: sessionId,
                                        code: smsVerify ? payload.code_sms : payload.code_ga,
                                        id: isCreateMode ? -1 : vm.item.id,
                                        name: fields.name.value,
                                        permissions: {
                                            spot: fields.permissions.spot.value,
                                            futures: fields.permissions.futures.value
                                        },
                                        ip_filter: fields.ip_filter.value,
                                        ips: fields.ips.value.filter((item) => item.name.length > 0)
                                    });
                                });
                            },
                            onCancel() {
                                vm.$store.commit('popupModule/setClosed');
                            }
                        }
                    }
                });
            });
        }
    },
    computed: Object.assign({}, mapGetters('user', ['getUserData'])),
    created() {
        const vm = this;
        if (Object.keys(vm.item).length) {
            setData(vm, vm.item);
        }
    },
    components: {
        ipsListItem
    }
});
